//Defaults
const defaults = {
  cartDrawer: ".js-ajax-cart-drawer", // classname
  cartDrawerContent: ".js-ajax-cart-drawer-content", // classname
  cartDrawerContentPage: ".js-ajax-cart-drawer-content-page", // classname
  cartDrawerTrigger: ".js-ajax-cart-drawer-trigger", // classname
  removeFromCart: ".remove-btn", //classname
  addLineItem: ".add-btn", //classname
  removeLineItem: ".subtract-btn", //classname
};

const cartDrawer = document.querySelector(defaults.cartDrawer);
const cartDrawerContent = document.querySelector(defaults.cartDrawerContent);
const cartDrawerContentPage = document.querySelector(defaults.cartDrawerContentPage);
const cartDrawerTrigger = document.querySelector(defaults.cartDrawerTrigger);

let removeFromCart = document.querySelectorAll(defaults.removeFromCart);
let addLineItem = document.querySelectorAll(defaults.addLineItem);
let removeLineItem = document.querySelectorAll(defaults.removeLineItem);
const htmlSelector = document.documentElement;

//Title Case
function titleCase(str) {
  str = str.toLowerCase().split(" ");
  for (var i = 0; i < str.length; i++) {
    str[i] = str[i].charAt(0).toUpperCase() + str[i].slice(1);
  }
  return str.join(" ");
}

//Clear Cart
const clearCart = function () {
  cartDrawerContent.innerHTML = "";
};

//Display Cart in Side Cart
const displayCart = function () {
  $.ajax({
    type: "GET",
    url: "/cart.js",
    dataType: "json",
    success: function (cart) {
      //console.log(cart);
      //onCartUpdate(cart);
      if (cart.item_count === 0) {
        //console.log('Cart is empty');
        updateSubtotal();

        killOverlay();
        document.querySelector("#side-cart").classList.remove("open");
        //document.querySelector('.cart-header-btn').classList.add('hide');

        if ($(".cart-page-loop").length) {
          updateSubtotalCartPage();
          document.querySelector(defaultsCartPage.cartPageCounter).innerHTML = cart.item_count;
        }
      } else {
        renderCart(cart);
        updateSubtotal();
        //document.querySelector('.cart-header-btn').classList.remove('hide');
        if ($(".cart-page-loop").length) {
          clearCartPage();
          renderCartPage(cart);
          updateSubtotalCartPage();
          document.querySelector(defaultsCartPage.cartPageCounter).innerHTML = cart.item_count;
        }
        //onsole.log('Cart has items');
      }

      let cartItems = cart.items;
      let giftStatus = false;

      cartItems.forEach(function (item, i) {
        if (item.id == 40412251127891) {
          document.querySelector('.bottom .gift').classList.add('hide');
          giftStatus = true;
          //console.log("It lives!");
        }
      });

      if (giftStatus) {
        document.querySelector(".bottom .gift").classList.add("hide");
        document.querySelector(".mobile-bottom .gift-two").classList.add("hide");
      } else {
        //console.log("It does not live!");
        // document.querySelector(".bottom .gift").classList.remove("hide");
        // document.querySelector(".mobile-bottom .gift-two").classList.remove("hide");
        // document.querySelector("#add-to-cart-gift").classList.remove("checked");
        // document.querySelector("#add-to-cart-gift-two").classList.remove("checked");
      }

      let cartCount = document.querySelectorAll(".cart-count");
      cartCount.forEach(function (item) {
        item.innerHTML = cart.item_count;
      });

      //onsole.log(cart);

    },
  });
};

//Remove Product From Cart
const removeProductFromCartCounter = function () {
  //cartCounter.innerHTML = Number(cartCounter.innerHTML) - 1;
};

//Change Quantity
const changeItem = function (line, callback) {
  const quantity = 0;
  $.ajax({
    type: "POST",
    url: "/cart/change.js",
    data: "quantity=" + quantity + "&line=" + line,
    dataType: "json",
    success: function (cart) {
      if (typeof callback === "function") {
        //console.log("Callback");
        callback(cart);
      } else {
        //console.log("fetcher");
        //onCartUpdate(cart);
        //console.log("Line= " + line + " and Callback= " + callback);
        clearCart();
        displayCart();
        updateSubtotal();
      }
    },
  });
};

//Add One Item
const addOneItem = function (line, qty, location) {
  let addNewQty = qty + 1;
  $.ajax({
    type: "POST",
    url: "/cart/change.js",
    data: "quantity=" + addNewQty + "&line=" + line,
    dataType: "json",
    success: function (cart) {
      if (typeof callback === "function") {
        //console.log("Callback");
        callback(cart);
      } else {
        //console.log("Adder");
        //onCartUpdate(cart);

        // clearCart();
        // displayCart();
        updateSubtotal();
        document.querySelectorAll(".ajax-cart-drawer__content li")[location].dataset.qty = addNewQty;
        renderQuantities(cart, location);

        // let currentChanger = document.querySelectorAll('[data-line')[location];
        // let currentValue = parseInt(currentChanger.querySelector('.c-quantity span').innerHTML);
        // let newQty = currentValue + 1;
        // currentChanger.querySelector('.c-quantity span').innerHTML = newQty;
      }
    },
  });
};

//Remove One Item
const subtractOneItem = function (line, qty, location) {
  let subNewQty = qty - 1;
  $.ajax({
    type: "POST",
    url: "/cart/change.js",
    data: "quantity=" + subNewQty + "&line=" + line,
    dataType: "json",
    success: function (cart) {
      if (typeof callback === "function") {
        //console.log("Callback");
        callback(cart);
      } else {
        //console.log("Remover");
        //onCartUpdate(cart);

        // clearCart();
        // displayCart();
        updateSubtotal();
        document.querySelectorAll(".ajax-cart-drawer__content li")[location].dataset.qty = subNewQty;
        renderQuantities(cart, location);

        // let currentChanger = document.querySelectorAll('[data-line')[location];
        // let currentValue = parseInt(currentChanger.querySelector('.c-quantity span').innerHTML);
        // let newQty = currentValue - 1;
        // currentChanger.querySelector('.c-quantity span').innerHTML = newQty;
      }
    },
  });
};

//Availability Property
const addCustomPropertyToCartItem = function(variantId, availability) {
  // Fetch the current cart
  fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {
      // Find the cart item that matches the variant ID
      const cartItem = cart.items.find(item => item.variant_id === variantId);

      //console.log(cartItem);

      if(!cartItem) {
        //console.error('Item not found in cart');
        return;
      } else {
        //console.log('Item found in cart:', cartItem.variant_id);
      }

      // Prepare the data with the custom property
      const updatedProperties = Object.assign({}, cartItem.properties, {
        "Availability": availability
      });

      const data = {
        "id": cartItem.key,
        "quantity": cartItem.quantity,
        "properties": updatedProperties
      };

      // Update the cart item with the custom property
      fetch('/cart/change.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(data),
        })
        .then(response => response.json())
        .then(cart => {
          //console.log('Cart item updated with custom property', cart);
          //console.log('Cart item updated with custom property: ', cartItem.properties);
          // Handle the updated cart here (e.g., update the cart UI)
        })
        .catch(error => {
          console.error('Error updating cart item:', error);
        });
    })
    .catch(error => {
      //console.error('Error fetching cart:', error);
    });
}

//Render Cart
const renderCart = function (cart) {
  cart.items.forEach(function (item, index) {
    //console.log(item.variant_id);
    //console.log(item);
    let dirtyHandle = item.handle;

    let pTitle = '<p class="c-title"><a href="' + item.url + '">' + item.product_title + "</a></p>";
    let dirtyImg = item.image;
    let splitImg = dirtyImg.split(".jpg");
    let largeImg = splitImg[0] + "_400x.jpg" + splitImg[1];
    //let largeImg = dirtyImg;
    //console.log(largeImg);
    let pImage = '<a href="' + item.url + '"><img src="' + largeImg + '"/></a>';
    let dirtyPrice = item.line_price;
    let roundedPrice = dirtyPrice / 100;

    let formatPrice = roundedPrice.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
    let pPrice = '<p class="c-price">$ ' + formatPrice + "</p>";
    let pQuantity = '<p class="c-quantity">Quantity: <a class="subtract-btn">–</a><span>' + item.quantity + '</span><a class="add-btn">+</a></p>';
    let pRemove = '<a class="remove-btn" href="#">Remove</a>';

    //let pRemove = '<p>' + defaults.removeFromCartNoDot + '</p>';
    let pInfo =
      '<li class="item" data-line="' +
      Number(index + 1) +
      '" data-qty="' +
      item.quantity +
      '">' +
      '<div class="left">' +
      pImage +
      "</div>" +
      '<div class="right">' +
      pTitle +
      pPrice +
      '<div class="c-variants"></div>' +
      pQuantity +
      '<p class="tags"></p>' +
      pRemove +
      '</div><div class="clear"></div></li>';

    cartDrawerContent.innerHTML = cartDrawerContent.innerHTML + pInfo;

    //console.log(item.options_with_values);

    let allVariants = item.options_with_values;
    let variantsWrap = document.querySelectorAll(".c-variants")[index];

    allVariants.forEach(function (tag, j) {
      //console.log(tag.name + ' ' + tag.value);

      let cleanTagName = titleCase(tag.name);
      let cleanValueName = titleCase(tag.value);

      if (cleanTagName == "Title") {
        variantsWrap.classList.add("remove-item");
      } else {
        let singleVariant = "<p>" + cleanTagName + ": " + cleanValueName + "</p>";
        variantsWrap.innerHTML = variantsWrap.innerHTML + singleVariant;
      }
    });

    //Availability
    let dirtyName = "/products/" + item.handle + ".js";
    let jackpotId = item.variant_id;

    //console.log(item.title);


    jQuery.getJSON(dirtyName, function (product) {
      //console.log(product);
      //console.log(product.handle);
      let varList = product.variants;
      varList.forEach(function (jtem) {
        //console.log(jtem);
        //console.log(jackpotId + " Jackpot");
        //console.log(jackpotId + " = " + jtem.id + " for " + jtem.name);
        if (jackpotId == jtem.id) {
          let currentAvail = String(jtem.inventory_policy);
          let currentInventoryString = jtem.inventory_quantity;
          let currentInventory = parseInt(currentInventoryString);

          //console.log(jtem.name + ' has ' + currentInventory + " available. Status is " + currentAvail + " first loop. Item: " + jntex);

          //console.log("Find: " + jtem.id + " Handle: " + jtem.name);
          //console.log(jtem.id);

          let cpTags = document.querySelectorAll(".tags");

          if (dirtyHandle != "gift-card") {
            if (currentInventory > 0) {
              if (cpTags[index]) {
                if (product.handle == "gift-wrapping") {
                  cpTags[index].innerHTML = "";
                } else {
                  //cpTags[index].innerHTML = "Availability: In stock.  Ships in 1-2 weeks.";
                  cpTags[index].innerHTML = "Availability: In stock";
                  addCustomPropertyToCartItem(jackpotId, "In stock");
                }
              }
            } else {
              if (cpTags[index]) {
                let eightTwelve = [
                  "onyx-dream-collar",
                  "coquille-hand-mirror-in-lapis",
                  "coquille-hand-mirror-in-onyx",
                  "nautilus-pill-box-in-onyx",
                  "coquille-paperweight",
                  "onyx-coquille-box",
                  "quartz-coquille-box",
                  "onyx-pyramid-cuff",
                  "quartz-pyramid-cuff",
                  "onyx-division-ring",
                  "onyx-dream-collar",
                  "onyx-crevice-pendant",

                  "large-coquille-pendant",
                  "lapis-division-collar",
                  "lapis-division-ring",
                  "lapis-donut-ring",
                  "small-coquille-pendant",
                  "quartz-division-ring",
                  "quartz-dream-collar",
                  "quartz-crevice-pendant",
                  "jade-division-ring",
                  "jade-division-collar",

                  "donut-ring",
                  "onyx-donut-ring",
                  "cyclops-lighter-case-in-onyx",
                  "four-eyes-small-votive",
                  "four-eyes-votive",
                  "one-eye-lighter-case-in-jade",
                  "jade-vienna-collar",
                  "evening-flask",

                  "rising-moon-flask",
                  "dusk-lighter-case",
                  "midnight-lighter-case",
                  "small-moon-pendant-in-onyx",
                  "long-dripping-stone-earrings-in-carnelian",
                  "medium-moon-pendant-in-carnelian",
                  "small-moon-pendant-in-carnelian",
                  "dripping-stone-earrings-in-carnelian",
                  "large-moon-pendant-in-onyx",
                  "medium-moon-pendant-in-onyx",

                  "dawn-lighter-case",
                  "pyramid-ring-in-onyx",
                  "tilde-ring",
                  "teardrop-pouch",
                  "long-teardrop-pouch",
                  "large-carnelian-pendant",
                  "medium-onyx-donut-ring",
                  "medium-jade-donut-ring",
                  "onyx-bagel-ear-cuff",
                  "vienna-collar-in-carnelian",

                  "onyx-donut-ring",
                  "large-spear-pendant-in-onyx",
                  "eclipse-lighter-case",
                  "twilight-lighter-case",
                  "large-spear-pendant",
                  "pearl-moon-ring",
                  "medium-angelika-earrings-in-jade",
                  "verona-comb",
                  "large-full-moon-pendant-in-quartz",
                  "egg-pendant-in-onyx",

                  "spear-earrings-in-quartz",
                  "large-spear-pendant-in-quartz",
                  "everyday-egg-pendant-in-onyx",
                  "small-full-moon-pendant-in-quartz",
                  "medium-full-moon-pendant-in-quartz",
                  "everyday-egg-choker-in-onyx",
                  "jade-bagel-ear-cuff",
                  "rinba-cuff",
                  "barbara-cuff",
                  "small-angelyne-earrings-in-onyx",

                  "dripping-stone-earrings-in-onyx",
                  "long-dripping-stone-earrings-in-onyx",
                  "jasper-division-ring",

                  "large-full-moon-pendant-in-jade",
                  "small-full-moon-pendant-in-jade",
                  "medium-full-moon-pendant-in-jade",
                  "egg-pendant-in-jade",
                  "everyday-egg-pendant-in-jade",
                  "everyday-egg-choker-in-jade",
                  "tiny-egg-pendant-in-jade",
                  "egg-choker-in-jade",

                  "cyclops-lighter-case-in-jade",
                  "cyclops-lighter-case-in-mother-of-pearl",
                  "nautilus-cigarette-case-sapphire",
                  "turin-comb",

                  "carnelian-moon-ring",

                  "chandelier-choker-in-onyx",
                  "chandelier-earrings-in-onyx",

                  "cleo-tassel-earrings",

                  "crystal-ball-1",
                  "perfume-vial-onyx-jade",
                  "perfume-vial-onyx-quartz",
                  "quartz-amulet-collar-onyx",
                  "quartz-amulet-collar-sterling-silver",
                  "anais-choker-1",
                  "large-spear-pendant-in-quartz",
                  "large-hiera-ring",
                  "onyx-pyramid-cuff",
                  "quartz-pyramid-cuff",
                  "pearl-moon-ring"

                ];

                let threeFour = [
                  "droplet-earrings-in-onyx",
                  "dripping-stone-earrings-in-vegetable-ivory",
                  "everyday-boule-earrings-tigers-eye",
                  "jasper-boule-collar",
                  "medium-chalcedony-collar",
                  "neue-pearl-earrings-in-jasper",
                  "neue-pearl-earrings-in-lapis",
                  "neue-pearl-earrings-in-onyx",
                  "quartz-donut-hoops",
                  "spear-earrings-in-carnelian",
                  "tigers-eye-donut-hoops",
                  "white-jade-donut-hoops"
                ]

                let preOrder = "";

                if (eightTwelve.includes(product.handle)) {
                  cpTags[index].innerHTML = "Availability: Made To Order. Ships in 8-12 weeks.";
                  addCustomPropertyToCartItem(jackpotId, "Made To Order. Ships in 8-12 weeks.");
                } else if (threeFour.includes(product.handle)) {
                  cpTags[index].innerHTML = "Availability: Made To Order. Ships in 3-4 weeks.";
                  addCustomPropertyToCartItem(jackpotId, "Made To Order. Ships in 3-4 weeks.");
                } else if (preOrder.includes(product.handle)) {
                  cpTags[index].innerHTML = "Order by July 19th for delivery by October 15th";
                  addCustomPropertyToCartItem(jackpotId, "Order by July 19th for delivery by October 15th");
                } else {
                  cpTags[index].innerHTML = "Availability: Made To Order. Ships in 6-8 weeks.";
                  addCustomPropertyToCartItem(jackpotId, "Made To Order. Ships in 6-8 weeks.");
                }
              }
            }
          }

        }
      });
    });
  });

  //Remove
  document.querySelectorAll(".remove-btn").forEach((element) => {
    element.addEventListener("click", function () {
      const lineID = this.parentNode.getAttribute("data-line");
      //console.log('aa');
    });
  });

  removeFromCart = document.querySelectorAll(defaults.removeFromCart);

  for (let i = 0; i < removeFromCart.length; i++) {
    removeFromCart[i].addEventListener("click", function (event) {
      event.preventDefault();
      const line = this.parentNode.parentNode.getAttribute("data-line");
      //console.log(line);
      let currentIndexer = i;
      changeItem(line, currentIndexer);
    });
  }

  //Add or Subtract
  addLineItem = document.querySelectorAll(defaults.addLineItem);

  for (let i = 0; i < addLineItem.length; i++) {
    addLineItem[i].addEventListener("click", function () {
      let linez = this.parentNode.parentNode.parentNode.getAttribute("data-line");
      let lineQTY = parseInt(this.parentNode.parentNode.parentNode.getAttribute("data-qty"));
      let currentIndexer = i;
      //console.log(linez + lineQTY);
      addOneItem(linez, lineQTY, currentIndexer);
    });
  }

  //Subtract
  removeLineItem = document.querySelectorAll(defaults.removeLineItem);

  for (let i = 0; i < addLineItem.length; i++) {
    removeLineItem[i].addEventListener("click", function () {
      let linez = this.parentNode.parentNode.parentNode.getAttribute("data-line");
      let lineQTY = parseInt(this.parentNode.parentNode.parentNode.getAttribute("data-qty"));
      let currentIndexer = i;
      //console.log(linez + lineQTY);
      if (lineQTY == 1) {
        changeItem(linez, currentIndexer);
      } else {
        subtractOneItem(linez, lineQTY, currentIndexer);
      }
    });
  }
};

const renderQuantities = function (cart, selecter) {
  cart.items.forEach(function (item, index) {
    if (selecter == index) {
      //console.log(item);
      let dirtyPrice = item.line_price;
      let roundedPrice = dirtyPrice / 100;
      let formatPrice = roundedPrice.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
      document.querySelectorAll(".c-price")[index].innerHTML = "$ " + formatPrice;
      document.querySelectorAll(".c-quantity span")[index].innerHTML = item.quantity;
    }
  });
};

const updateSubtotal = function () {
  $.ajax({
    type: "GET",
    url: "/cart.js",
    dataType: "json",
    success: function (cart) {
      //onCartUpdate(cart);

      document.querySelector("#mobile-cart-counter").innerHTML = cart.item_count;
      document.querySelector("#cart-counter").innerHTML = cart.item_count;

      if (cart.item_count === 0) {
        document.querySelector("#side-cart-subtotal").innerHTML = "$ 0.00";
        document.querySelector("#side-cart").classList.add("empty");
      } else {
        let dirtyPrice = cart.items_subtotal_price;
        let roundedPrice = dirtyPrice / 100;
        let formatPrice = roundedPrice.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");

        document.querySelector("#side-cart-subtotal").innerHTML = "$ " + formatPrice;
        document.querySelector(".mobile-bottom .subtotal .right").innerHTML = "$ " + formatPrice;
        document.querySelector(".sticky-bottom .right").innerHTML = "$ " + formatPrice;
      }
    },
  });
};

displayCart();

let atcGift = document.querySelectorAll(".gift-checkbox");

atcGift.forEach(function (item, i) {
  item.addEventListener("click", function (event) {
    event.preventDefault();
    item.classList.add("checked");

    dater = {
      id: 40412251127891,
      quantity: 1,
    };

    jQuery.ajax({
      type: "POST",
      url: "/cart/add.js",
      data: dater,
      dataType: "json",
      success: function () {
        //console.log("Gift wrapping successfully added");
        clearCart();
        displayCart();
      },
    });
  });
});